import { SEMAINE, FACE } from '@/configuration/devisConf';

export function toggleTarifUnitaire(ligneRegroupement) {
  if (!ligneRegroupement.lignesCommande
    || !ligneRegroupement.ligneReseau
   || !ligneRegroupement.ligneReseau.qteFacesSouhaitees) {
    return;
  }
  ligneRegroupement.lignesCommande
    .filter((ligne) => {
      return !ligne.calculAutomatiqueTlpe;
    })
    .forEach(ligneEnfant => {
      if (ligneEnfant.quantite == null) {
        ligneEnfant.quantite = 1;
      }
      if (ligneEnfant.uniteVente == null) {
        ligneEnfant.uniteVente = SEMAINE;
      }
      if (ligneRegroupement.tarifUnitaire) {
        ligneEnfant.quantite = Number(ligneRegroupement.ligneReseau.qteFacesSouhaitees);
        ligneEnfant.uniteVente = FACE;
      }
    });
}

export function passageTarifUnitaireDepuisPlanningReseauTempo(ligneRegroupement) {
  if (!ligneRegroupement.lignesCommande
    || !ligneRegroupement.ligneReseau
   || !ligneRegroupement.ligneReseau.qteFacesSouhaitees) {
    return;
  }
  ligneRegroupement.lignesCommande
    .filter((ligne) => {
      return !ligne.calculAutomatiqueTlpe;
    })
    .forEach(ligneEnfant => {
      if (ligneRegroupement.tarifUnitaire) {
        ligneEnfant.quantite = Number(ligneRegroupement.ligneReseau.qteFacesSouhaitees);
        ligneEnfant.uniteVente = FACE;
      }
    });
}

export function onUpdateQteFaceSouhaitee(ligneRegroupement) {
  if (!ligneRegroupement.tarifUnitaire) {
    return;
  }
  ligneRegroupement.lignesCommande
    .filter(ligne => !ligne.calculAutomatiqueTlpe)
    .forEach(ligneEnfant => {
      ligneEnfant.quantite = Number(ligneRegroupement.ligneReseau.qteFacesSouhaitees);
    });
}

export function updateTotalHtLignesEnfant(ligneRegroupement) {
  if (!ligneRegroupement.lignesCommande) {
    return;
  }
  ligneRegroupement.lignesCommande
    .filter((ligne) => {
      return !ligne.calculAutomatiqueTlpe;
    })
    .forEach(ligneEnfant => {
      ligneEnfant.totalHt = ligneEnfant.quantite * ligneEnfant.prixUnitaire;
    });
}
